import { combineReducers, configureStore } from '@reduxjs/toolkit';
// import counterReducer from '../features/counter/counterSlice';
import counterReducer from './counterSlice';
import storage from 'redux-persist/lib/storage';
import userReducer from './userSlice';
import { persistReducer, persistStore } from 'redux-persist';
import autoMergeLevel2 from 'redux-persist/lib/stateReconciler/autoMergeLevel2';


const persistConfig = {
	key: 'root',
	storage,
	stateReconciler: autoMergeLevel2,
	blacklist:['counter']
  }
  const rootReducer = combineReducers({ 
	counter: counterReducer,
	userInfo: userReducer,
  })
  const persistedReducer = persistReducer(persistConfig, rootReducer)

export const store = configureStore({
	reducer: persistedReducer,
});

export const persistor = persistStore(store)